/* tslint:disable */
/* eslint-disable */
/**
 * Roles API
 * API for managing user roles
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Un portail accessible au compte (mode portail du refacto rôles), avec ses briques effectives (briques du portail ∩ briques assignées au compte).
 * 
 * @export
 * @interface PortailMinimalDto
 */
export interface PortailMinimalDto {
    /**
     * Nom du portail (Codes.Portails — Distribution, Plateforme)
     * @type {string}
     * @memberof PortailMinimalDto
     */
    nom: string;
    /**
     * Briques effectives du compte dans ce portail
     * @type {Array<string>}
     * @memberof PortailMinimalDto
     */
    briques: Array<string>;
}

/**
 * Check if a given object implements the PortailMinimalDto interface.
 */
export function instanceOfPortailMinimalDto(value: object): value is PortailMinimalDto {
    if (!('nom' in value) || value['nom'] === undefined) return false;
    if (!('briques' in value) || value['briques'] === undefined) return false;
    return true;
}

export function PortailMinimalDtoFromJSON(json: any): PortailMinimalDto {
    return PortailMinimalDtoFromJSONTyped(json, false);
}

export function PortailMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortailMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nom': json['nom'],
        'briques': json['briques'],
    };
}

export function PortailMinimalDtoToJSON(json: any): PortailMinimalDto {
    return PortailMinimalDtoToJSONTyped(json, false);
}

export function PortailMinimalDtoToJSONTyped(value?: PortailMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nom': value['nom'],
        'briques': value['briques'],
    };
}

